import { useQuery } from "@tanstack/react-query";
import { adminSearchService } from "../../../services/adminSearch";
import { useAdminSearchStore } from "../store/adminSearchStore";

export function useAdminSearchVideos() {
  const { videosState } = useAdminSearchStore();
  const { filters, pagination, sort, order } = videosState;

  const queryKey = [
    "adminSearchVideos_key",
    {
      filters: {
        userInput: filters.userInput,
        videoSource: filters.videoSource,
        videoType: filters.videoType,
        videoCreated: filters.videoCreated,
        golfClub: filters.golfClub,
        cameraAngle: filters.cameraAngle,
      },
      page: pagination.page,
      limit: pagination.limit,
      sort,
      order,
    },
  ];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const payload = {
        page: pagination.page,
        limit: pagination.limit,
      };
      if (sort) {
        payload.sort = sort;
        payload.order = order || "asc";
      }

      const filtersPayload = {};
      if (
        filters.userInput != null &&
        String(filters.userInput).trim() !== ""
      ) {
        filtersPayload.userInput = String(filters.userInput).trim();
      }
      if (
        filters.videoSource != null &&
        String(filters.videoSource).trim() !== ""
      ) {
        filtersPayload.videoSource = filters.videoSource;
      }
      if (
        filters.videoType != null &&
        String(filters.videoType).trim() !== ""
      ) {
        filtersPayload.videoType = filters.videoType;
      }
      if (
        filters.cameraAngle != null &&
        String(filters.cameraAngle).trim() !== ""
      ) {
        filtersPayload.cameraAngle = filters.cameraAngle;
      }
      if (filters.videoCreated?.from || filters.videoCreated?.to) {
        filtersPayload.videoCreated = {};
        if (filters.videoCreated.from)
          filtersPayload.videoCreated.from = filters.videoCreated.from;
        if (filters.videoCreated.to)
          filtersPayload.videoCreated.to = filters.videoCreated.to;
      }
      if (Array.isArray(filters.golfClub) && filters.golfClub.length > 0) {
        filtersPayload.golfClub = filters.golfClub.filter(Boolean);
      }

      payload.filters =
        Object.keys(filtersPayload).length > 0 ? filtersPayload : {};

      const res = await adminSearchService.adminSearchVideos(payload);
      return {
        videos: res.videos || [],
        total: res.total || 0,
      };
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
